import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table
} from 'reactstrap';
import { ClipLoader } from 'react-spinners';
import api from '../../../../Api';

export default function CourseHistoryModal({
  isOpen,
  toggle,
  history,
  userName,
  userId
}) {
  const loading = history === null;
  const rows = history ? Object.values(history) : [];

  const [classProgress, setClassProgress] = useState({});
  const [progressLoading, setProgressLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [unitData, setUnitData] = useState({});


  const visibleRows = rows;

  useEffect(() => {
    setClassProgress({});
    setExpanded({});
    setUnitData({});
  }, [userId]);

  useEffect(() => {
    if (loading) return;
    if (!isOpen || !userId) {
      setClassProgress({});
      return;
    }

  // aqui eu deixo vejo as classes (busco as turmas visíveis e suas units)
    (async () => {
      setProgressLoading(true);
      try {
        const fetches = visibleRows.map(row => {
          const classId = row.course.id;
          return api.getAcessoClassRoom(classId, userId)
            .then(res => ({ classId, units: res.data.units || [] }))
            .catch(() => ({ classId, units: [] }));
        });

        const results = await Promise.all(fetches);

  // aqui mapeio os progressos e units (construo maps de progresso por turma e cache das units)
  const progressMap = {};
  const unitsMap = {};

  for (const r of results) {
          const units = r.units || [];
          unitsMap[r.classId] = { loading: false, data: units };

          let totalLessons = 0;
          let doneLessons = 0;
          for (const u of units) {
            const lessons = Array.isArray(u.lessons) ? u.lessons : [];
            totalLessons += lessons.length;
            for (const l of lessons) {
              if (Array.isArray(l.progress) && l.progress.length) doneLessons++;
            }
          }

          progressMap[r.classId] = totalLessons ? Math.round((doneLessons * 100) / totalLessons) : 0;
        }

  setUnitData(prev => ({ ...prev, ...unitsMap }));
  setClassProgress(progressMap);
      } catch (err) {
        console.error('Erro ao carregar progresso do curso por usuário', err);
        setClassProgress({});
      } finally {
        setProgressLoading(false);
      }
    })();
  }, [loading, userId, isOpen]);

  const handleToggle = async classId => {
    const isOpenNow = !!expanded[classId];
    setExpanded(prev => ({ ...prev, [classId]: !isOpenNow }));
    if (!isOpenNow && !unitData[classId]) {
      setUnitData(prev => ({ ...prev, [classId]: { loading: true } }));
      try {
        if (!userId) throw new Error('missing userId');
        const res   = await api.getAcessoClassRoom(classId, userId);
        const units = res.data.units || [];
        setUnitData(prev => ({
          ...prev,
          [classId]: { loading: false, data: units }
        }));
      } catch {
        setUnitData(prev => ({
          ...prev,
          [classId]: { loading: false, data: [] }
        }));
      }
  }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Histórico de Cursos: {userName}
      </ModalHeader>
      <ModalBody style={{ minHeight: '200px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <ClipLoader size={50} />
          </div>
        ) : (
          <Table striped style={{ tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: '40%' }}>Turma</th>
                <th style={{ width: '20%' }}><center>Progresso (%)</center></th>
                <th style={{ width: '20%' }}><center>Projetos Entregues</center></th>
                <th style={{ width: '20%' }}><center>Faltas</center></th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map(({ course, progressList = [], presenceList = [] }) => {
                const classId  = course.id;
                const pct      = classProgress[classId] ?? 0;
                const projects = progressList.filter(p => p.type === 0).length;
                const absences = presenceList
                  .filter(p => String(p.status).trim().toLowerCase() === 'falta')
                  .length;

                return (
                  <React.Fragment key={classId}>
                    <tr
                      onClick={() => handleToggle(classId)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                        {course.name}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {progressLoading
                          ? <ClipLoader size={15} />
                          : pct
                        }
                      </td>
                      <td><center>{projects}</center></td>
                      <td><center>{absences}</center></td>
                    </tr>
                    {expanded[classId] && (
                      <tr>
                        <td colSpan="4">
                          {unitData[classId]?.loading ? (
                            <em>Carregando units…</em>
                          ) : (
                            <Table size="sm" style={{ width: '100%' }}>
                              <thead>
                                <tr>
                                  <th>Unit</th>
                                  <th>Progresso (%)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {unitData[classId].data.map(unit => {
                                  const total = unit.lessons.length;
                                  const done  = unit.lessons.filter(
                                    l => l.progress.length
                                  ).length;
                                  const upct = total
                                    ? Math.round((done * 100) / total)
                                    : 0;
                                  return (
                                    <tr key={unit.id}>
                                      <td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                                        {unit.name}
                                      </td>
                                      <td>{upct}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          )}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
              {visibleRows.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center">
                    Nenhuma turma encontrada.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
        {!loading && visibleRows.length === 0 && (
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h4>Nenhum curso encontrado.</h4>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}